// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const BarChartIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6 18a1 1 0 01-1-1v-6a1 1 0 012 0v6a1 1 0 01-1 1zm4 0a1 1 0 01-1-1V3a1 1 0 012 0v14a1 1 0 01-1 1zm4 0a1 1 0 01-1-1V5a1 1 0 012 0v12a1 1 0 01-1 1zm4 0a1 1 0 01-1-1V9a1 1 0 012 0v8a1 1 0 01-1 1zm3 4H3a1 1 0 110-2h18a1 1 0 010 2z"/><path d="M5.02 12h2v6h-2zm4 0h2v6h-2zm4 0h2v6h-2zm4 0h2v6h-2z"/></svg>'} />;

(BarChartIcon as any).displayName = 'BarChartIcon';

export default BarChartIcon;
